import { BlocksStatusIndicator } from 'blocks-nextjs/blocks-web-components/components/status-indicator/status-indicator';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatStatusIndicator = createComponent({ react: React, tagName: 'cat-status-indicator', elementClass: BlocksStatusIndicator });
